import React from 'react'
import { Form, Input, Dropdown, Label } from 'semantic-ui-react'

// Define period options
const PERIOD_OPTIONS = [
  { key: 'day', text: 'Day(s)', value: 'day' },
  { key: 'week', text: 'Week(s)', value: 'week' },
  { key: 'month', text: 'Month(s)', value: 'month' }
]

/**
 * Rental duration input component with period selection using Semantic UI
 */
const RentDurationInputUI = ({
  value = '',
  onChange,
  periodValue = 'day',
  onPeriodChange,
  error,
  required = false,
  disabled = false,
  compact = false,
  placeholder = '0',
  ...props
}) => {
  const handleDurationChange = (e, { value: newValue }) => {
    // Only allow positive integers
    if (newValue === '' || /^[0-9]*$/.test(newValue)) {
      // Call the parent's onChange with either a number or empty string
      const numValue = newValue === '' ? '' : Number(newValue)
      onChange({
        target: {
          name: props.name || 'duration',
          value: numValue
        }
      })
    }
  }

  const handlePeriodChange = (e, { value: period }) => {
    if (onPeriodChange) {
      onPeriodChange(period)
    }
  }

  return (
    <Form.Field required={required} error={!!error}>
      <Input
        placeholder={placeholder}
        value={value}
        onChange={handleDurationChange}
        disabled={disabled}
        error={!!error}
        labelPosition='right'
        size={compact ? 'small' : 'medium'}
        action={
          <Dropdown
            button
            basic
            floating
            options={PERIOD_OPTIONS}
            value={periodValue}
            onChange={handlePeriodChange}
            disabled={disabled}
            compact={compact}
            text={PERIOD_OPTIONS.find(p => p.value === periodValue)?.text || 'Day(s)'}
          />
        }
        {...props}
      />

    </Form.Field>
  )
}

export default RentDurationInputUI 